import type { User } from "@/context/UserProvider";

// The server derives development_suite_municipality_ids from the
// development_suite flag on the user's workspace team for each municipality.
// The frontend only reads it; the API enforces the same gate on every request.

/** True when the suite is open in at least one of the user's municipalities. */
export function userHasDevelopmentSuite(user: User | null | undefined): boolean {
  return (user?.development_suite_municipality_ids?.length ?? 0) > 0;
}

export function canUseDevelopmentSuiteIn(
  user: User | null | undefined,
  municipalityId: number | null | undefined,
): boolean {
  if (municipalityId == null) return false;
  return Boolean(user?.development_suite_municipality_ids?.includes(municipalityId));
}
